"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var React = _interopRequireWildcard(require("react"));
const SvgCaretDown = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M21.743 5.99a.75.75 0 0 0-.523.23L12 15.44 2.78 6.22a.75.75 0 1 0-1.06 1.06l9.75 9.75a.75.75 0 0 0 1.06 0l9.75-9.75a.75.75 0 0 0-.537-1.29"
  }));
};
var _default = exports.default = SvgCaretDown;